import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { useTituloContext } from 'context/TituloContext';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { RequestTituloStoreProps } from 'pages/financeiro/titulo/types';

export function useQueryTitulos() {
    const { filter, autoLoad, sort, limit } = useListagemContext();
    const RequestListagem = useRequestListagem();
    const { setHasTitulos } = useTituloContext();

    const requestOptions: RequestOptionsType = {
        sort,
        filter,
        limit,
        nested: true,
        url: '/financeiro/titulo',
        columns: 'nrNotaFiscal,nrTitulo,dtEmissao,dtVencimentoFormatada,vlTitulo,fgImpresso,tituloTipoNota',
    };

    return useQuery<RequestTituloStoreProps>(['getTitulos', requestOptions], () => RequestListagem(requestOptions).then((res) => res.data), {
        enabled: autoLoad,
        onSuccess: (response) => setHasTitulos(Boolean(response.total)),
        onError: () => setHasTitulos(false),
    });
}
